module.exports = __webpack_public_path__ + "src/assets/static/img/icn_menu_closed.427a5659.svg";